import { AnyAction } from "redux";

const INIT_STATE: string = "";

export default function groups(
    state = INIT_STATE,
    action: AnyAction
): string | null {
    if (action.type === "GROUPS") {
        return action.payload;
    } else {
        return state !== undefined ? state : null;
    }
}
